/**
 * ReDelivery v1
 * El delivery mas coopado
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';


import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class RateService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param cdUser 
     * @param cdStore 
     * @param cdOrder 
     * @param nmStar 
     * @param dsComment 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiRatePostForm(cdUser?: number, cdStore?: number, cdOrder?: number, nmStar?: number, dsComment?: string, observe?: 'body', reportProgress?: boolean): Observable<number>;
    public apiRatePostForm(cdUser?: number, cdStore?: number, cdOrder?: number, nmStar?: number, dsComment?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<number>>;
    public apiRatePostForm(cdUser?: number, cdStore?: number, cdOrder?: number, nmStar?: number, dsComment?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<number>>;
    public apiRatePostForm(cdUser?: number, cdStore?: number, cdOrder?: number, nmStar?: number, dsComment?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {






        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'multipart/form-data'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): void; };
        let useForm = false;
        let convertFormParamsToString = false;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        }

        if (cdUser !== undefined) {
            formParams = formParams.append('CdUser', <any>cdUser) as any || formParams;
        }
        if (cdStore !== undefined) {
            formParams = formParams.append('CdStore', <any>cdStore) as any || formParams;
        }
        if (cdOrder !== undefined) {
            formParams = formParams.append('CdOrder', <any>cdOrder) as any || formParams;
        }
        if (nmStar !== undefined) {
            formParams = formParams.append('NmStar', <any>nmStar) as any || formParams;
        }
        if (dsComment !== undefined) {
            formParams = formParams.append('DsComment', <any>dsComment) as any || formParams;
        }

        return this.httpClient.request<number>('post',`${this.basePath}/api/Rate`,
            {
                body: convertFormParamsToString ? formParams.toString() : formParams,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
